import { useEffect, useRef } from 'react';
import clsx from 'clsx';
import Depot from '../../../../_shared/depot';
import { setMultipleRefs } from '../../../../_shared/helpers';
const TargetWithoutRef = ({ maxWidth, margin, xOffset, yOffset, targetClasses, innerRef, children, className, ...commonProps }) => {
    // Ref
    const targetRef = useRef(null);
    // Classes
    const classes = clsx(className, targetClasses);
    // Effect
    useEffect(() => {
        if (targetRef.current) {
            targetRef.current.style.setProperty('--dp-bubble-max-width', maxWidth !== null && maxWidth !== void 0 ? maxWidth : '300px');
            targetRef.current.style.setProperty('--dp-bubble-x-offset', xOffset !== null && xOffset !== void 0 ? xOffset : '50%');
            targetRef.current.style.setProperty('--dp-bubble-y-offset', yOffset !== null && yOffset !== void 0 ? yOffset : '50%');
            targetRef.current.style.setProperty('--dp-bubble-margin-offset', margin !== null && margin !== void 0 ? margin : '0px');
        }
    }, [maxWidth, margin, xOffset, yOffset]);
    return Depot.createElement('div', {
        innerRef: setMultipleRefs([innerRef, targetRef]),
        className: classes,
        ...commonProps,
    }, children);
};
const Target = Depot.withRef(TargetWithoutRef);
Target.displayName = 'Target';
export default Target;
//# sourceMappingURL=index.js.map